<template>
  <div>
    <shift-filters
      :currentFilters="currentFilters"
      :statusFetched="statusFetched"
      :statusClosed="statusClosed"
      :statusPartiallyClosed="statusPartiallyClosed"
      :closedPeriods="closedPeriods"
      @statusChanged="handleStatusChanged"
    ></shift-filters>

    <shift-assign-form
      :visible="assignmentFormVisible"
      :currentFilters="currentFilters"
      :shiftsOptions="shiftsOptions"
      :checkedEmployees="checkedEmployees"
      :status="status"
      @close="assignmentFormVisible = false"
      @submitted="handleShiftAssigned"
    ></shift-assign-form>

    <shift-copy
      :visible="copyAndRotateFormVisible"
      :currentFilters="currentFilters"
      :shiftsOptions="shiftsOptions"
      :rotation="rotation"
      @close="copyAndRotateFormVisible = false"
      @submitted="handleCopyAndRotate"
    ></shift-copy>

      <el-alert
        v-if="unassignedMondayPrenocCount > 0 && !statusClosed"
        type="warning"
        show-icon
        style="margin-bottom: 12px; border: 1px solid #e6a23c; padding: 10px 15px;"
        :closable="false"
      >
        <template slot="title">
          <div>
            <strong style="font-size: 14px;">⚠️ Alerta de Programación (Turno PRENOC / Nocturno):</strong>
            <span>Se detectaron <strong>{{ unassignedMondayPrenocCount }} empleados</strong> sin turno asignado para el <strong>Lunes</strong>.</span>
          </div>
        </template>
      </el-alert>

      <el-row v-if="!statusClosed && !showFileUploadForm && !showInTableShiftAssignment">
        <el-col :xs="24">
          <el-button
            @click.prevent="handleShowAssignmentForm"
            :disabled="checkedEmployees.length == 0 || !this.$auth.can(['shifts.assign'])"
            icon="el-icon-time"
            size="mini"
          >Asignar turno</el-button>
          <el-button
            @click.prevent="handleShowAssignmentNotification"
            :disabled="!this.$auth.can(['shifts.assign'])"
            icon="el-icon-time"
            size="mini"
          >Asignar turno (nuevo)</el-button>
          <el-button
            @click.prevent="handleUploadFile"
            :disabled="!this.$auth.can(['shifts.assign'])"
            icon="el-icon-time"
            size="mini"
          >Subir archivo</el-button>
          <el-button
            @click.prevent="copyAndRotateFormVisible = true"
            :disabled="!this.$auth.can(['shifts.assign']) || closedPeriods.length > 0"
            icon="el-icon-refresh"
            size="mini"
          >Copiar y rotar turnos</el-button>
          <el-button
            :disabled="downloadUrl == null || !this.$auth.can(['shifts.assign', 'shifts.view'])"
            @click="downloadReport()"
            icon="el-icon-download"
            size="mini"
          >Descargar a Excel</el-button>
        </el-col>
      </el-row>

      <shift-file-upload
        v-if="showFileUploadForm"
        @close="showFileUploadForm = false"
        @fileUploaded="handleFileUploaded"
      />

      <div
        class="box box-info"
        id="inTableShiftAssignmentForm"
        v-if="showInTableShiftAssignment"
      >
        <div class="box-header" style="display: flex; align-items: center; justify-content: space-between; padding-right: 20px;">
          <h5 style="margin: 0; font-weight: bold; font-size: 15px;">
            <i class="fa fa-clock-o" style="margin-right: 5px;"></i> Asignación rápida (Seleccione una opción y haga clic en las celdas de la tabla)
          </h5>
          <div class="box-tools pull-right">
            <button
              type="button"
              class="btn btn-box-tool"
              @click="handleCancelInTableShiftAssignment"
              data-original-title="Cancelar"
            >
              <i class="fa fa-times" style="font-size: 16px;"></i>
            </button>
          </div>
        </div>
        <div class="box-body" style="padding: 10px 15px;">
          <div style="margin-bottom: 10px;">
            <el-button
              size="mini"
              :style="getClearButtonStyle()"
              @click="selectClear"
            >
              <i class="fa fa-trash" style="margin-right: 4px;"></i> ELIMINAR ASIGNACIÓN
            </el-button>
          </div>

          <!-- Seccion Turnos -->
          <div style="margin-bottom: 12px;">
            <div style="font-weight: bold; font-size: 12px; color: #337ab7; margin-bottom: 6px;">
              <i class="fa fa-calendar-check-o" style="margin-right: 4px;"></i> TURNOS:
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 4px;">
              <el-button
                v-for="option in shiftsOptions"
                :key="'shift-' + option.value"
                :style="getShiftButtonStyle(option)"
                size="mini"
                @click="selectShift(option)"
              >{{ option.label }}</el-button>
            </div>
          </div>

          <!-- Seccion Permisos / Licencias -->
          <div v-if="excusesOptionsList && excusesOptionsList.length > 0">
            <div style="font-weight: bold; font-size: 12px; color: #d9534f; margin-bottom: 6px;">
              <i class="fa fa-exclamation-circle" style="margin-right: 4px;"></i> PERMISOS / LICENCIAS:
            </div>
            <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 6px;">
              <el-button
                v-for="option in excusesOptionsList"
                :key="'excuse-' + option.value"
                :style="getExcuseButtonStyle(option)"
                size="mini"
                @click="selectExcuse(option)"
              >
                <i class="fa fa-exclamation-circle" style="margin-right: 3px;"></i> {{ option.label }}
              </el-button>
            </div>


          </div>
        </div>
        <div class="box-footer" style="padding: 8px 15px;">
          <div style="float: left; font-size: 12px; color: #555; line-height: 28px;">
            <span v-if="selectedShiftOption && selectedShiftOption.clear" style="color: #d9534f; font-weight: bold;">
              <i class="fa fa-arrow-right"></i> Opción activa: ELIMINAR ASIGNACIÓN
            </span>
            <span v-else-if="selectedShiftOption && selectedShiftOption.isExcuse" style="color: #e6a23c; font-weight: bold;">
              <i class="fa fa-arrow-right"></i> Opción activa: Permiso ({{ selectedShiftOption.label }})
            </span>
            <span v-else-if="selectedShiftOption" style="color: #337ab7; font-weight: bold;">
              <i class="fa fa-arrow-right"></i> Opción activa: Turno ({{ selectedShiftOption.label }})
            </span>
            <span v-else style="color: #999;">
              <i>Haga clic en un turno o permiso arriba para comenzar a asignar.</i>
            </span>
          </div>
          <div class="box-tools pull-right">
            <el-button size="mini" @click="handleCancelInTableShiftAssignment">Cancelar</el-button>
            <el-button
              type="primary"
              size="mini"
              :disabled="inTableShiftAssignmentConfirmButtonDisabled"
              @click="handleConfirmInTableShiftAssignment"
            >Confirmar cambios</el-button>
          </div>
        </div>
      </div>

      <el-table
        :data="assignments"
        :span-method="spanMethod"
        border
        stripe
        @select-all="handleSelectAll"
        @select="handleSelect"
        @cell-click="handleCellClick"
        ref="employeesTable"
        id="assignmentsTable"
        max-height="600"
        v-loading="loadingData"
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          width="40"
        > </el-table-column>
        <el-table-column
          label="Empleado"
          width="180"
          column-key="employee"
          :filtered-value="tableFilterEmployee"
          :filters="[{ text: '-', value: '-' }]"
          :filter-method="employeesTableFilterHandler"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">{{ scope.row.last_name }}, {{ scope.row.first_name }}
            (<template v-if="scope.row.roster">{{scope.row.roster.description}}</template> - <template v-if="scope.row.labor_agreement">{{ scope.row.labor_agreement.description }} - {{scope.row.labor_agreement.definition.hours_per_week}}hs.</template>)
          </template>
        </el-table-column>
        <el-table-column
          v-for="day in week_days"
          :label="day.label + lineBreak + day.date"
          :key="day.date"
          :column-key="day.date"
          class-name="date-cell"
          label-class-name="date-cell-label"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.computedShifts && scope.row.computedShifts[day.date]"
              style="height:100%; width:100%; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 2px; padding: 1px 2px; box-sizing: border-box;"
            >
              <!-- Turno Badge -->
              <el-tooltip
                v-if="scope.row.computedShifts[day.date].hasShift"
                effect="dark"
                :content="scope.row.computedShifts[day.date].shift"
                placement="top"
              >
                <div
                  :style="
                    'font-size: 11px; line-height: 1.2; width:100%; padding: 2px 4px; border-radius: 3px; font-weight: bold; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; background-color:' +
                      (scope.row.computedShifts[day.date].shiftColor || '#3c8dbc') +
                      ';color:' +
                      invertColor(scope.row.computedShifts[day.date].shiftColor || '#3c8dbc', true)
                  "
                >
                  {{ scope.row.computedShifts[day.date].shift }}
                </div>
              </el-tooltip>

              <!-- Permiso / Licencia Badge -->
              <el-tooltip
                v-if="scope.row.computedShifts[day.date].hasExcuse"
                effect="dark"
                placement="top"
              >
                <template slot="content">
                  <div><strong>Permiso:</strong> {{ scope.row.computedShifts[day.date].excuse }}</div>
                  <div><strong>Horario:</strong> {{ scope.row.computedShifts[day.date].isFullDay !== false ? 'Jornada Completa (Todo el día)' : (scope.row.computedShifts[day.date].timeFrom + ' a ' + scope.row.computedShifts[day.date].timeTo) }}</div>
                  <div><strong>Justificación:</strong> {{ scope.row.computedShifts[day.date].observations || 'Sin observación' }}</div>
                </template>
                <div
                  :style="
                    'font-size: 11px; line-height: 1.2; width:100%; padding: 2px 4px; border-radius: 3px; font-weight: bold; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; background-color:' +
                      (scope.row.computedShifts[day.date].excuseColor || '#d9534f') +
                      ';color:' +
                      invertColor(scope.row.computedShifts[day.date].excuseColor || '#d9534f', true)
                  "
                >
                  <i class="fa fa-exclamation-circle" style="margin-right: 2px;"></i>
                  {{ scope.row.computedShifts[day.date].excuse }}
                  <span v-if="scope.row.computedShifts[day.date].isFullDay === false && scope.row.computedShifts[day.date].timeFrom" style="font-size: 10px; font-weight: normal; opacity: 0.95;">
                    ({{ scope.row.computedShifts[day.date].timeFrom }}-{{ scope.row.computedShifts[day.date].timeTo }})
                  </span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- Dialog Configurar Permiso -->
      <el-dialog
        title="Configurar Permiso / Licencia"
        :visible.sync="permissionModalVisible"
        width="450px"
        :close-on-click-modal="false"
        append-to-body
      >
        <div v-if="permissionForm.row" style="padding: 5px;">
          <div style="margin-bottom: 15px; padding: 10px; background-color: #f4f6f9; border-radius: 4px; border-left: 4px solid #3c8dbc;">
            <div><strong>Empleado:</strong> {{ permissionForm.row.last_name }}, {{ permissionForm.row.first_name }}</div>
            <div><strong>Fecha:</strong> {{ permissionForm.selDate }}</div>
            <div style="margin-top: 4px;">
              <strong>Permiso:</strong>
              <span
                :style="'display: inline-block; padding: 2px 8px; border-radius: 3px; font-weight: bold; color: #fff; background-color:' + permissionForm.excuseColor"
              >
                {{ permissionForm.excuseLabel }}
              </span>
            </div>
          </div>

          <el-form label-position="top" size="small">
            <el-form-item label="Tipo de Duración:">
              <el-radio-group v-model="permissionForm.isFullDay">
                <el-radio :label="true">Jornada Completa (Todo el día)</el-radio>
                <el-radio :label="false">Horario Parcial (Definir Horas)</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-row :gutter="10" v-if="!permissionForm.isFullDay" style="margin-bottom: 10px;">
              <el-col :span="12">
                <el-form-item label="Hora Inicio:">
                  <el-time-select
                    v-model="permissionForm.timeFrom"
                    :picker-options="{ start: '00:00', step: '00:15', end: '23:45' }"
                    placeholder="Hora inicio"
                    style="width: 100%;"
                  ></el-time-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Hora Fin:">
                  <el-time-select
                    v-model="permissionForm.timeTo"
                    :picker-options="{ start: '00:00', step: '00:15', end: '23:45', minTime: permissionForm.timeFrom }"
                    placeholder="Hora fin"
                    style="width: 100%;"
                  ></el-time-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="Justificación / Motivo:">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="Escriba la justificación o motivo del permiso..."
                v-model="permissionForm.observations"
              ></el-input>
              <div v-if="permissionForm.isJustified" style="font-size: 11px; color: #d9534f; margin-top: 3px;">
                <i class="fa fa-info-circle"></i> Este permiso es justificado; se requieren observaciones.
              </div>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="permissionForm.isEditing" type="danger" size="small" style="float: left;" @click="removePermissionFromModal">
            Eliminar Permiso
          </el-button>
          <el-button size="small" @click="permissionModalVisible = false">Cancelar</el-button>
          <el-button type="primary" size="small" @click="savePermissionFromModal">Guardar Permiso</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<style type="text/css">
td.date-cell div.cell {
  position: absolute;
  top: 3px;
  width: 100%;
  height: 89%;
  padding: 0 2px;
}
th.date-cell-label div.cell {
  white-space: pre;
  text-align: center;
}
.selected-button {
  font-size: 20px;
}
/* .selected-button span::before {
        content: "v "
    } */
#inTableShiftAssignmentForm .box-body .el-button:first-child {
  margin-left: 9px;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { invertColor } from "../../utils/lib";
import shift_file_upload from "./shift-file-upload.vue";
import shift_filters from "./shift-filters";
import shift_assign_form from "./shift-assign-form";
import shift_copy from "./shift-copy";
let colspan = 1;
export default {
  data() {
    return {
      assignmentFormVisible: false,
      shiftsHoursByDayOfWeek: {},
      lastSelectedShiftButton: null,
      showInTableShiftAssignment: false,
      loadingData: false,
      status: [],
      statusFetched: false,
      statusClosed: false,
      statusPartiallyClosed: false,
      closedPeriods: "",
      showFileUploadForm: false,
      lineBreak: "\n",
      employeesTableVisible: false,
      assignmentNotification: null,
      assignmentsByDate: {},
      overridedAssignments: {},
      copyAndRotateFormVisible: false,
      checkedEmployees: [],
      currentFilters: {
        functional_area_id: null,
        date_from: null,
        date_to: null,
      },
      shiftsOptions: [],
      shiftsLoaded: false,
      assignments: [],
      week_days: [],
      tableFilterEmployeeFilters: null,
      tableFilterEmployee: ["-"],
      employeesFilters: {
        filter: null,
        labor_agreement_id: null,
        roster_id: null,
      },
      downloadUrl: null,
      shiftSelected: null,
      selectedShiftOption: null,
      selectedOptionKey: null,
      rotation: [],
      selectedBulkMondayShiftId: null,
      quickExcuseObservations: "",
      permissionModalVisible: false,
      permissionForm: {
        row: null,
        selDate: null,
        column: null,
        cell: null,
        event: null,
        excuseId: null,
        excuseLabel: "",
        excuseColor: "#d9534f",
        isJustified: true,
        isFullDay: true,
        timeFrom: "08:00",
        timeTo: "17:00",
        observations: "",
        isEditing: false,
      },
    };
  },
  computed: {
    ...mapGetters(["excuses"]),
    excusesOptionsList() {
      if (!this.excuses) return [];
      return _.map(this.excuses, (item, index) => {
        const val = item.value || item.id;
        const color = this.getExcuseColor(val, index);
        return {
          label: item.label || item.description,
          value: val,
          color: color,
          justified: item.justified !== undefined ? item.justified : true,
          paid: item.paid !== undefined ? item.paid : true,
        };
      });
    },
    inTableShiftAssignmentConfirmButtonDisabled: function () {
      return _.isEmpty(this.assignmentsByDate);
    },
    mondayDateStr: function () {
      if (!this.week_days || this.week_days.length === 0) return null;
      let mon = this.week_days.find((d) => d.day_of_week === 'lun' || d.day_of_week === 'mon' || (d.label && d.label.indexOf('Lunes') >= 0));
      return mon ? mon.date : null;
    },
    unassignedMondayPrenocCount: function () {
      if (!this.mondayDateStr || !this.assignments || this.assignments.length === 0) return 0;
      let count = 0;
      this.assignments.forEach((emp) => {
        if (!emp.computedShifts || !emp.computedShifts[this.mondayDateStr] || !emp.computedShifts[this.mondayDateStr].hasShift) {
          count++;
        }
      });
      return count;
    },
  },
  components: {
    "shift-file-upload": shift_file_upload,
    "shift-filters": shift_filters,
    "shift-assign-form": shift_assign_form,
    "shift-copy": shift_copy,
  },
  mounted() {
    this.fillFiltersForm();
    this.setDownloadUrl();
    this.colspan = 1;
    this.setDays();
    this.fetchExcuses();
    this.loadInfo(this.$route.query);
  },
  beforeRouteLeave(to, from, next) {
    if (!_.isEmpty(this.assignmentsByDate)) {
      this.$confirm(
        "Hay modificaciones pendientes de confirmación. Seguro desea descartar los cambios?",
        "Alerta",
        {
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(() => {
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  watch: {
    $route: function (to) {
      this.fillFiltersForm();
      this.setDays();
      this.loadInfo(to.query);
      this.setDownloadUrl();
    },
  },
  methods: {
    ...mapActions(["fetchExcuses"]),
    invertColor,
    selectClear() {
      if (this.selectedOptionKey === 'clear') {
        this.selectedOptionKey = null;
        this.shiftSelected = null;
        this.selectedShiftOption = null;
      } else {
        this.selectedOptionKey = 'clear';
        this.shiftSelected = 'clear';
        this.selectedShiftOption = {
          label: null,
          value: null,
          color: '#FFFFFF',
          clear: true
        };
      }
    },
    selectShift(option) {
      const key = 'shift-' + option.value;
      if (this.selectedOptionKey === key) {
        this.selectedOptionKey = null;
        this.shiftSelected = null;
        this.selectedShiftOption = null;
      } else {
        this.selectedOptionKey = key;
        this.shiftSelected = option.value;
        this.selectedShiftOption = {
          value: option.value,
          label: option.label,
          color: option.color || '#3c8dbc',
          isExcuse: false
        };
      }
    },
    getExcuseColor(excuseId, index) {
      const palette = [
        "#d9534f", // Crimson Red
        "#e67e22", // Vivid Orange
        "#8e44ad", // Deep Purple
        "#27ae60", // Emerald Green
        "#2980b9", // Belize Blue
        "#f39c12", // Amber Yellow
        "#16a085", // Teal
        "#c0392b", // Brick Red
        "#9b59b6", // Amethyst
        "#17a2b8", // Info Cyan
        "#d35400", // Pumpkin
        "#34495e"  // Dark Slate
      ];
      let idx = (typeof index === "number") ? index : (excuseId ? Math.abs(parseInt(excuseId, 10) % palette.length) : 0);
      if (isNaN(idx)) idx = 0;
      return palette[idx % palette.length];
    },
    selectExcuse(option) {
      const key = 'excuse-' + option.value;
      if (this.selectedOptionKey === key) {
        this.selectedOptionKey = null;
        this.shiftSelected = null;
        this.selectedShiftOption = null;
      } else {
        this.selectedOptionKey = key;
        this.shiftSelected = 'excuse_' + option.value;
        const excuseColor = option.color || this.getExcuseColor(option.value);
        this.selectedShiftOption = {
          isExcuse: true,
          excuseId: option.value,
          label: 'P: ' + option.label,
          color: excuseColor,
          value: 'excuse_' + option.value,
          justified: option.justified !== undefined ? option.justified : true,
          paid: option.paid !== undefined ? option.paid : true,
        };
      }
    },
    getClearButtonStyle() {
      const isSelected = this.selectedOptionKey === 'clear';
      return {
        'min-width': '100px',
        'border': isSelected ? '2px solid #ac2925' : '1px solid #d9534f',
        'font-weight': isSelected ? 'bold' : 'normal',
        'box-shadow': isSelected ? '0 0 5px rgba(217,83,79,0.8)' : 'none'
      };
    },
    getShiftButtonStyle(option) {
      const isSelected = this.selectedOptionKey === ('shift-' + option.value);
      const bgColor = option.color || '#3c8dbc';
      const textColor = this.invertColor(bgColor, true);
      return {
        'min-width': '100px',
        'background-color': bgColor,
        'color': textColor,
        'margin-bottom': '4px',
        'border': isSelected ? '3px solid #000' : '1px solid #ccc',
        'font-weight': isSelected ? 'bold' : 'normal',
        'box-shadow': isSelected ? '0 0 6px rgba(0,0,0,0.6)' : 'none',
        'transform': isSelected ? 'scale(1.04)' : 'none',
        'transition': 'all 0.15s ease-in-out'
      };
    },
    getExcuseButtonStyle(option) {
      const isSelected = this.selectedOptionKey === ('excuse-' + option.value);
      const bgColor = option.color || this.getExcuseColor(option.value);
      const textColor = this.invertColor(bgColor, true);
      return {
        'min-width': '100px',
        'background-color': bgColor,
        'color': textColor,
        'margin-bottom': '4px',
        'border': isSelected ? '3px solid #000' : '1px solid ' + bgColor,
        'font-weight': isSelected ? 'bold' : 'normal',
        'box-shadow': isSelected ? '0 0 6px rgba(0,0,0,0.6)' : 'none',
        'transform': isSelected ? 'scale(1.04)' : 'none',
        'transition': 'all 0.15s ease-in-out'
      };
    },
    autoFillMondayPrenoc() {
      if (!this.mondayDateStr) return;
      if (!this.selectedBulkMondayShiftId) {
        this.$message.warning('Por favor seleccione el turno que desea aplicar masivamente al Lunes.');
        return;
      }
      let shiftOption = this.shiftsOptions.find((opt) => opt.value === this.selectedBulkMondayShiftId);
      if (!shiftOption) {
        this.$message.warning('El turno seleccionado no es válido.');
        return;
      }

      let count = 0;
      let assignments = [...this.assignments];
      assignments.forEach((emp) => {
        if (!emp.computedShifts) emp.computedShifts = {};
        let cellObj = emp.computedShifts[this.mondayDateStr];
        if (!cellObj || !cellObj.hasShift) {
          if (!this.assignmentsByDate[emp.id]) {
            this.assignmentsByDate[emp.id] = [];
          }
          let idx = this.assignmentsByDate[emp.id].findIndex((el) => el.date === this.mondayDateStr);
          if (idx === -1) {
            this.assignmentsByDate[emp.id].push({ date: this.mondayDateStr, shiftId: shiftOption.value });
          } else {
            this.assignmentsByDate[emp.id][idx].shiftId = shiftOption.value;
            delete this.assignmentsByDate[emp.id][idx].removeShift;
          }
          if (!cellObj) {
            emp.computedShifts[this.mondayDateStr] = {
              hasShift: true,
              shift: shiftOption.label,
              shiftId: shiftOption.value,
              shiftColor: shiftOption.color || '#3c8dbc',
              colspan: 1,
              badge: true,
            };
          } else {
            cellObj.hasShift = true;
            cellObj.shift = shiftOption.label;
            cellObj.shiftId = shiftOption.value;
            cellObj.shiftColor = shiftOption.color || '#3c8dbc';
          }
          count++;
        }
      });
      this.assignments = assignments;
      this.assignmentsByDate = Object.assign({}, this.assignmentsByDate);
      this.showInTableShiftAssignment = true;
      this.$message.success(`Se aplicó masivamente el turno "${shiftOption.label}" a ${count} empleados para el Lunes. Presione 'Confirmar' para guardar los cambios.`);
    },
    fillFiltersForm: function () {
      _.each(this.currentFilters, (value, key) => {
        this.currentFilters[key] = this.$route.query[key] || null;
      });
    },
    handleStatusChanged() {
      this.getStatus();
    },
    handleShowAssignmentForm() {
      // if (this.statusClosed) return;
      this.assignmentFormVisible = true;
    },
    handleShiftAssigned() {
      this.assignmentFormVisible = false;
      this.checkedEmployees = [];
      this.loadInfo();
    },
    handleCopyAndRotate() {
      this.copyAndRotateFormVisible = false;
      this.loadInfo();
    },
    handleUploadFile() {
      this.showFileUploadForm = true;
    },
    handleFileUploaded() {
      this.showFileUploadForm = false;
      this.loadInfo(this.$route.query);
    },
    handleCancelInTableShiftAssignment() {
      if (!_.isEmpty(this.assignmentsByDate)) {
        this.$confirm(
          "Hay modificaciones pendientes de confirmación. Seguro desea descartar los cambios?",
          "Alerta",
          {
            confirmButtonText: "Descartar cambios",
            cancelButtonText: "Cancelar",
            type: "warning",
          }
        ).then(() => {
          this.lastSelectedShiftButton = null;
          this.selectedOptionKey = null;
          this.shiftSelected = null;
          this.selectedShiftOption = null;
          this.showInTableShiftAssignment = false;
          this.assignmentsByDate = {};
          this.loadInfo(this.$route.query);
        });
      } else {
        this.lastSelectedShiftButton = null;
        this.selectedOptionKey = null;
        this.shiftSelected = null;
        this.selectedShiftOption = null;
        this.showInTableShiftAssignment = false;
        this.assignmentsByDate = {};
      }
    },
    handleConfirmInTableShiftAssignment() {
      if (!_.isEmpty(this.assignmentsByDate)) {
        this.loadingData = true;
        axios
          .post("/api/employees/shiftsbulk", { data: this.assignmentsByDate })
          .then((response) => {
            this.lastSelectedShiftButton = null;
            this.selectedOptionKey = null;
            this.shiftSelected = null;
            this.selectedShiftOption = null;
            this.showInTableShiftAssignment = false;
            this.assignmentsByDate = {};
            this.$message.success("Asignación de turnos/permisos guardada correctamente.");
            this.loadInfo(this.$route.query);
          })
          .catch((error) => {
            this.loadingData = false;
            let msg = "Error al guardar las asignaciones.";
            if (error.response && error.response.data && error.response.data.error) {
              msg += " " + error.response.data.error;
            }
            this.$message.error(msg);
          });
      }
    },
    getStatus() {
      this.statusFetched = false;
      axios
        .get(
          "/api/functionalareas/" +
          this.currentFilters.functional_area_id +
          "/statusbydate",
          {
            params: {
              aspect: "SA",
              date_from: this.currentFilters.date_from,
              date_to: this.currentFilters.date_to,
            },
          }
        )
        .then((response) => {
          let closed = true;
          let partiallyClosed = false;
          let closedPeriods = [];
          // console.log(response.data);
          this.status = response.data;
          this.week_days.forEach((day) => {
            let st = response.data.find(
              (elem) => elem.date_from <= day.date && elem.date_to >= day.date
            );
            if (st != undefined && st.status == "CLO") {
              partiallyClosed = true;
            } else {
              closed = false;
            }
          });
          response.data.forEach((elem) => {
            if (elem.status == "CLO") {
              closedPeriods.push(`${elem.date_from} a ${elem.date_to}`);
            }
          });
          this.closedPeriods = closedPeriods.join(", ");
          this.statusClosed = closed;
          this.statusPartiallyClosed = partiallyClosed;
          this.statusFetched = true;
        });
    },
    handleEmployeesFilter() {
      let text = [];
      if (this.employeesFilters.filter != null) {
        text.push("Empleado: " + this.employeesFilters.filter);
      }
      if (this.employeesFilters.labor_agreement_id != null) {
        text.push("Acuerdo: " + this.employeesFilters.labor_agreement_id);
      }
      if (this.employeesFilters.roster_id != null) {
        text.push("Nómina: " + this.employeesFilters.roster_id);
      }

      text = text.join(" - ");
      this.tableFilterEmployeeFilters = [{ text: text, value: "-" }];
      this.tableFilterEmployee = ["-"];

      // console.log(this.tableFilterEmployeeFilters);
      // this.$refs['employeesTable'].$forceUpdate();

      // this.$nextTick(() => {
      //     this.assignments.push({last_name:'', first_name:'', company_id_number:'', id_number:'', shifts:[]});
      //     this.assignments.pop();
      // });
    },
    handleClearEmployeesFilters() {
      this.employeesFilters.filter = null;
      this.employeesFilters.labor_agreement_id = null;
      this.employeesFilters.roster_id = null;
      this.tableFilterEmployeeFilters = null;
      this.tableFilterEmployee = ["-"];
      // this.$nextTick(() => {
      //     this.assignments.push({last_name:'', first_name:'', company_id_number:'', id_number:'', shifts:[]});
      //     this.assignments.pop();
      // });
    },
    employeesTableFilterHandler(value, row, column) {
      // value = value.toLowerCase();
      // console.log(value);
      // console.log(row);
      // console.log(column);

      let pass = true;

      if (this.employeesFilters.filter != null) {
        let filter = this.employeesFilters.filter.toLowerCase().trim();
        // console.log(filter);
        if (
          row.last_name.toLowerCase().indexOf(filter) >= 0 ||
          row.first_name.toLowerCase().indexOf(filter) >= 0 ||
          row.id_number.indexOf(filter) >= 0 ||
          row.company_id_number.indexOf(filter) >= 0
        ) {
          pass = true;
        } else {
          pass = false;
        }
      }

      if (pass == true && this.employeesFilters.labor_agreement_id != null) {
        if (
          row.labor_agreement_id != this.employeesFilters.labor_agreement_id
        ) {
          pass = false;
        }
      }

      if (pass == true && this.employeesFilters.roster_id != null) {
        if (row.roster_id != this.employeesFilters.roster_id) {
          pass = false;
        }
      }

      if (pass && this.checkedEmployees.includes(row.id)) {
        this.$refs["employeesTable"].toggleRowSelection(row, "selected");
      }

      return pass;
    },
    handleCellClick(row, column, cell, event) {
      let selDate = column.columnKey;
      if (!selDate) return;

      let st = this.status.find(
        (elem) => elem.date_from <= selDate && elem.date_to >= selDate
      );
      if (st != undefined && st.status == "CLO") {
        this.$alert(
          "El día seleccionado corresponde a un período cerrado",
          "Error",
          { confirmButtonText: "Cerrar" }
        );
        return;
      }

      let existingCell = row.computedShifts ? row.computedShifts[selDate] : null;

      // 1. Selection mode (no option selected in top bar) -> Edit permission if present
      if (this.shiftSelected === null) {
        if (existingCell && existingCell.hasExcuse) {
          this.openPermissionModal(row, selDate, column, cell, event, {
            excuseId: existingCell.excuseId,
            excuseLabel: existingCell.excuse,
            excuseColor: existingCell.excuseColor || "#d9534f",
            isJustified: true,
            isFullDay: existingCell.isFullDay !== false,
            timeFrom: existingCell.timeFrom || "08:00",
            timeTo: existingCell.timeTo || "17:00",
            observations: existingCell.observations || "",
            isEditing: true
          });
        }
        return;
      }

      // 2. Permission option selected from top bar
      if (this.selectedShiftOption && this.selectedShiftOption.isExcuse) {
        let isJustified = this.selectedShiftOption.justified !== false && this.selectedShiftOption.justified !== 0 && this.selectedShiftOption.justified !== '0';
        let excuseLabel = (this.selectedShiftOption.label || "Permiso").replace(/^P:\s*/, "");
        let excuseColor = this.selectedShiftOption.color || this.getExcuseColor(this.selectedShiftOption.excuseId);

        let isEditing = existingCell && existingCell.hasExcuse && existingCell.excuseId === this.selectedShiftOption.excuseId;
        
        this.openPermissionModal(row, selDate, column, cell, event, {
          excuseId: this.selectedShiftOption.excuseId,
          excuseLabel: excuseLabel,
          excuseColor: excuseColor,
          isJustified: isJustified,
          isFullDay: isEditing ? (existingCell.isFullDay !== false) : true,
          timeFrom: isEditing ? (existingCell.timeFrom || "08:00") : "08:00",
          timeTo: isEditing ? (existingCell.timeTo || "17:00") : "17:00",
          observations: isEditing ? (existingCell.observations || "") : "",
          isEditing: isEditing
        });
        return;
      }

      // 3. Clear option or Shift option
      let itemAssignment = { date: selDate };
      let assignments = [...this.assignments];

      if (this.selectedShiftOption && this.selectedShiftOption.clear) {
        itemAssignment.clear = true;
        itemAssignment.removeShift = true;
        itemAssignment.removeExcuse = true;
      } else if (this.selectedShiftOption && this.selectedShiftOption.value) {
        itemAssignment.shiftId = this.selectedShiftOption.value;
      }

      this.executeCellAssignment(row, column, cell, event, selDate, itemAssignment, assignments);
    },
    openPermissionModal(row, selDate, column, cell, event, opts) {
      this.permissionForm = {
        row: row,
        selDate: selDate,
        column: column,
        cell: cell,
        event: event,
        excuseId: opts.excuseId,
        excuseLabel: opts.excuseLabel,
        excuseColor: opts.excuseColor,
        isJustified: opts.isJustified,
        isFullDay: opts.isFullDay !== undefined ? opts.isFullDay : true,
        timeFrom: opts.timeFrom || "08:00",
        timeTo: opts.timeTo || "17:00",
        observations: opts.observations || "",
        isEditing: !!opts.isEditing
      };
      this.permissionModalVisible = true;
    },
    savePermissionFromModal() {
      if (this.permissionForm.isJustified && (!this.permissionForm.observations || !this.permissionForm.observations.trim())) {
        this.$message.warning("La justificación es obligatoria para este tipo de permiso.");
        return;
      }
      if (!this.permissionForm.isFullDay) {
        if (!this.permissionForm.timeFrom || !this.permissionForm.timeTo) {
          this.$message.warning("Por favor ingrese la hora de inicio y fin.");
          return;
        }
        if (this.permissionForm.timeFrom >= this.permissionForm.timeTo) {
          this.$message.warning("La hora de inicio debe ser anterior a la hora de fin.");
          return;
        }
      }

      const row = this.permissionForm.row;
      const selDate = this.permissionForm.selDate;
      const assignments = [...this.assignments];

      let timeFrom = this.permissionForm.isFullDay ? "00:00" : this.permissionForm.timeFrom;
      let timeTo = this.permissionForm.isFullDay ? "23:59" : this.permissionForm.timeTo;
      let observations = this.permissionForm.observations ? this.permissionForm.observations.trim() : "Asignación rápida";

      if (!assignments[row.idx].computedShifts) {
        assignments[row.idx].computedShifts = {};
      }
      let cellObj = assignments[row.idx].computedShifts[selDate];
      if (!cellObj) {
        cellObj = { colspan: 1, badge: true };
        assignments[row.idx].computedShifts[selDate] = cellObj;
      }

      cellObj.hasExcuse = true;
      cellObj.excuse = "P: " + this.permissionForm.excuseLabel.replace(/^P:\s*/, "");
      cellObj.excuseId = this.permissionForm.excuseId;
      cellObj.excuseColor = this.permissionForm.excuseColor;
      cellObj.observations = observations;
      cellObj.timeFrom = timeFrom;
      cellObj.timeTo = timeTo;
      cellObj.isFullDay = this.permissionForm.isFullDay;
      cellObj.isExcuse = true;

      if (!this.assignmentsByDate[row.id]) {
        this.assignmentsByDate[row.id] = [];
      }
      let existingIdx = this.assignmentsByDate[row.id].findIndex(e => e.date === selDate);
      let batchItem = existingIdx !== -1 ? this.assignmentsByDate[row.id][existingIdx] : { date: selDate };

      batchItem.excuseId = this.permissionForm.excuseId;
      batchItem.isExcuse = true;
      batchItem.observations = observations;
      batchItem.time_from = timeFrom + ":00";
      batchItem.time_to = timeTo + ":00";
      batchItem.datetime_from = selDate + " " + batchItem.time_from;
      batchItem.datetime_to = selDate + " " + batchItem.time_to;
      delete batchItem.removeExcuse;
      delete batchItem.clear;

      if (existingIdx === -1) {
        this.assignmentsByDate[row.id].push(batchItem);
      } else {
        this.assignmentsByDate[row.id][existingIdx] = batchItem;
      }

      this.assignmentsByDate[row.id] = _.sortBy(this.assignmentsByDate[row.id], e => e.date);
      this.assignments = assignments;
      this.assignmentsByDate = Object.assign({}, this.assignmentsByDate);
      this.permissionModalVisible = false;
      this.showInTableShiftAssignment = true;
      this.$message.success("Permiso configurado correctamente. Presione 'Confirmar cambios' para guardar.");
    },
    removePermissionFromModal() {
      const row = this.permissionForm.row;
      const selDate = this.permissionForm.selDate;
      const assignments = [...this.assignments];

      let cellObj = assignments[row.idx].computedShifts ? assignments[row.idx].computedShifts[selDate] : null;
      if (cellObj) {
        cellObj.hasExcuse = false;
        delete cellObj.excuse;
        delete cellObj.excuseId;
        delete cellObj.excuseColor;
        delete cellObj.observations;
        delete cellObj.timeFrom;
        delete cellObj.timeTo;
        delete cellObj.isFullDay;
        delete cellObj.isExcuse;
        if (!cellObj.hasShift) {
          delete assignments[row.idx].computedShifts[selDate];
        }
      }

      if (!this.assignmentsByDate[row.id]) {
        this.assignmentsByDate[row.id] = [];
      }
      let existingIdx = this.assignmentsByDate[row.id].findIndex(e => e.date === selDate);
      let batchItem = existingIdx !== -1 ? this.assignmentsByDate[row.id][existingIdx] : { date: selDate };

      batchItem.removeExcuse = true;
      delete batchItem.excuseId;
      delete batchItem.isExcuse;
      delete batchItem.observations;
      delete batchItem.time_from;
      delete batchItem.time_to;
      delete batchItem.datetime_from;
      delete batchItem.datetime_to;

      if (existingIdx === -1) {
        this.assignmentsByDate[row.id].push(batchItem);
      } else {
        this.assignmentsByDate[row.id][existingIdx] = batchItem;
      }

      this.assignmentsByDate[row.id] = _.sortBy(this.assignmentsByDate[row.id], e => e.date);
      this.assignments = assignments;
      this.assignmentsByDate = Object.assign({}, this.assignmentsByDate);
      this.permissionModalVisible = false;
      this.showInTableShiftAssignment = true;
      this.$message.info("Permiso desasignado. Presione 'Confirmar cambios' para guardar.");
    },
    executeCellAssignment(row, column, cell, event, selDate, itemAssignment, assignments) {
      let st = this.status.find(
        (elem) => elem.date_from <= selDate && elem.date_to >= selDate
      );
      if (st != undefined && st.status == "CLO") {
        this.$alert(
          "El día seleccionado corresponde a un período cerrado",
          "Error",
          {
            confirmButtonText: "Cerrar",
          }
        );
        return;
      }

      if (!assignments[row.idx].computedShifts) {
        assignments[row.idx].computedShifts = {};
      }

      let cellObj = assignments[row.idx].computedShifts[selDate];

      if (!this.assignmentsByDate[row.id]) {
        this.assignmentsByDate[row.id] = [];
      }

      let existingBatchIdx = this.assignmentsByDate[row.id].findIndex(e => e.date === selDate);
      let batchItem = existingBatchIdx !== -1 ? this.assignmentsByDate[row.id][existingBatchIdx] : { date: selDate };

      if (itemAssignment.clear) {
        delete assignments[row.idx].computedShifts[selDate];
        batchItem.clear = true;
        batchItem.removeShift = true;
        batchItem.removeExcuse = true;
        delete batchItem.shiftId;
        delete batchItem.excuseId;
      } else if (itemAssignment.isExcuse) {
        if (cellObj && cellObj.hasExcuse && cellObj.excuseId === itemAssignment.excuseId) {
          cellObj.hasExcuse = false;
          delete cellObj.excuse;
          delete cellObj.excuseId;
          delete cellObj.excuseColor;
          delete cellObj.observations;
          delete cellObj.isExcuse;
          if (!cellObj.hasShift) {
            delete assignments[row.idx].computedShifts[selDate];
          }
          batchItem.removeExcuse = true;
          delete batchItem.excuseId;
          delete batchItem.isExcuse;
          delete batchItem.observations;
        } else {
          if (!cellObj) {
            cellObj = { colspan: 1, badge: true };
            assignments[row.idx].computedShifts[selDate] = cellObj;
          }
          cellObj.hasExcuse = true;
          cellObj.excuse = this.selectedShiftOption.label;
          cellObj.excuseId = this.selectedShiftOption.excuseId;
          cellObj.excuseColor = this.selectedShiftOption.color;
          cellObj.observations = itemAssignment.observations;
          cellObj.isExcuse = true;

          batchItem.excuseId = itemAssignment.excuseId;
          batchItem.isExcuse = true;
          batchItem.observations = itemAssignment.observations;
          delete batchItem.removeExcuse;
          delete batchItem.clear;
        }
      } else if (itemAssignment.shiftId) {
        if (cellObj && cellObj.hasShift && cellObj.shiftId === itemAssignment.shiftId) {
          cellObj.hasShift = false;
          delete cellObj.shift;
          delete cellObj.shiftId;
          delete cellObj.shiftColor;
          if (!cellObj.hasExcuse) {
            delete assignments[row.idx].computedShifts[selDate];
          }
          batchItem.removeShift = true;
          delete batchItem.shiftId;
        } else {
          if (!cellObj) {
            cellObj = { colspan: 1, badge: true };
            assignments[row.idx].computedShifts[selDate] = cellObj;
          }
          cellObj.hasShift = true;
          cellObj.shift = this.selectedShiftOption.label;
          cellObj.shiftId = this.selectedShiftOption.value;
          cellObj.shiftColor = this.selectedShiftOption.color;

          batchItem.shiftId = itemAssignment.shiftId;
          delete batchItem.removeShift;
          delete batchItem.clear;
        }
      }

      if (existingBatchIdx === -1) {
        this.assignmentsByDate[row.id].push(batchItem);
      } else {
        this.assignmentsByDate[row.id][existingBatchIdx] = batchItem;
      }

      this.assignmentsByDate[row.id] = _.sortBy(this.assignmentsByDate[row.id], (elem) => elem.date);
      this.assignments = assignments;
      this.assignmentsByDate = Object.assign({}, this.assignmentsByDate);
    },
    handleSelectAll(selection) {
      // console.log(value);
      let checkedEmployees = [...this.checkedEmployees];
      if (selection.length > 0) {
        _.each(selection, (employee) => {
          if (!checkedEmployees.includes(employee.id)) {
            checkedEmployees.push(employee.id);
          }
        });
      } else {
        _.each(this.$refs["employeesTable"].tableData, (employee) => {
          checkedEmployees.splice(checkedEmployees.indexOf(employee.id), 1);
        });
      }
      this.checkedEmployees = checkedEmployees;
    },
    handleSelect(selection, employee) {
      let adding = false;

      for (let i in selection) {
        if (selection[i].id == employee.id) {
          adding = true;
          break;
        }
      }

      if (adding) {
        this.checkedEmployees.push(employee.id);
      } else {
        this.checkedEmployees.splice(
          this.checkedEmployees.indexOf(employee.id),
          1
        );
      }
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      return [1, 1];
    },
    setDays() {
      moment.locale("es");
      let date_from = moment(this.$route.query["date_from"]);
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      let week_days = [];
      for (let i = 0; i < 7; i++) {
        week_days.push({
          date: date_from.format("YYYY-MM-DD"),
          label: days[date_from.format("d")],
          day_of_week: date_from.format("ddd").toLowerCase(),
          idx: i,
        });
        date_from.add(1, "days");
      }
      this.week_days = week_days;
    },
    loadInfo(query) {
      // console.log(query);

      if (
        this.currentFilters.functional_area_id == null ||
        this.currentFilters.date_from == null ||
        this.currentFilters.date_to == null
      ) {
        // console.log('some null value')
        return;
      }

      this.loadingData = true;

      // this.copyAndRotateForm.copy.date_from = this.currentFilters.date_from;
      // this.copyAndRotateForm.copy.date_to = this.currentFilters.date_to;
      // this.copyAndRotateForm.functional_area_id = this.currentFilters.functional_area_id;

      let shifts_functional_areas;

      this.employeesTableVisible = true;
      this.setDownloadUrl();
      this.getStatus();

      axios
        .get(
          "/api/functionalareas/" +
          this.currentFilters.functional_area_id +
          "/shifts"
        )
        .then((response) => {
          // let shifts = _.sortBy(response.data, (item) => { return item.definition.mon_check_in_time});
          let shifts = _.sortBy(response.data, (item) => {
            return item.description;
          });
          // _.each(response.data.data, (shift) => {
          let shiftsOptions = [];
          this.rotation = [];
          shifts_functional_areas = {};
          _.each(shifts, (shift) => {
            let desc =
              shift.pivot.description != null
                ? shift.pivot.description + " - "
                : "";
            // let lbl = desc + shift.company_id_number + ' (' + shift.description + ')';
            // let lbl = desc + shift.company_id_number;
            let lbl = desc + shift.description;
            shiftsOptions.push({
              label: lbl,
              value: shift.id,
              color: shift.definition.color,
            });
            // console.log(this.shiftsOptions);
            shifts_functional_areas["s" + shift.id] = lbl;
            this.rotation.push({ orig: shift.id, dest: null });
          });
          this.shiftsOptions = shiftsOptions;
          if (shiftsOptions.length > 0) {
            let prenocOpt = shiftsOptions.find(o => o.label && o.label.toUpperCase().includes('PRENOC'));
            this.selectedBulkMondayShiftId = prenocOpt ? prenocOpt.value : shiftsOptions[0].value;
          }
          let shiftsHoursByDayOfWeek = {};
          response.data.forEach((shift) => {
            shiftsHoursByDayOfWeek[shift.id] = [];
            this.week_days.forEach((day) => {
              if (!isNaN(shift.definition[day.day_of_week + "_hours"])) {
                shiftsHoursByDayOfWeek[shift.id].push(
                  shift.definition[day.day_of_week + "_hours"]
                );
              } else {
                shiftsHoursByDayOfWeek[shift.id].push(0);
              }
            });
          });
          this.shiftsHoursByDayOfWeek = shiftsHoursByDayOfWeek;

          this.shiftsOptions = shiftsOptions;
          // console.log(this.shiftsOptions);

          axios
            .get(
              "/api/employees/shiftassignment?functional_area_id=" +
              this.currentFilters.functional_area_id +
              "&date_from=" +
              this.currentFilters.date_from +
              "&date_to=" +
              this.currentFilters.date_to
            )
            .then((response) => {
              // console.log(response);

              if (this.colspan > 1) {
                this.colspan--;
                return [0, 0];
              }

              let week_date_from_str = this.week_days[0].date;
              let week_date_to_str = this.week_days[this.week_days.length - 1].date;

              for (let j in response.data.data) {
                let row = response.data.data[j];
                row.computedShifts = {};
                row.idx = j;
                for (let i in row.shifts) {
                  let sPivot = row.shifts[i].pivot;
                  let shiftStart = sPivot.date_from < week_date_from_str ? week_date_from_str : sPivot.date_from;
                  let shiftEnd = sPivot.date_to > week_date_to_str ? week_date_to_str : sPivot.date_to;

                  let curDate = moment(shiftStart);
                  let endDate = moment(shiftEnd);
                  while (curDate.isSameOrBefore(endDate)) {
                    let dStr = curDate.format("YYYY-MM-DD");
                    if (!row.computedShifts[dStr]) {
                      row.computedShifts[dStr] = { colspan: 1 };
                    }
                    let shiftDef = row.shifts[i].definition;
                    let color = (shiftDef && typeof shiftDef === 'object' && shiftDef.color) ? shiftDef.color : '#3c8dbc';

                    row.computedShifts[dStr].hasShift = true;
                    row.computedShifts[dStr].shift = shifts_functional_areas["s" + row.shifts[i].id] || row.shifts[i].description;
                    row.computedShifts[dStr].shiftId = row.shifts[i].id;
                    row.computedShifts[dStr].shiftColor = color;
                    row.computedShifts[dStr].updated_by = sPivot.updated_by;
                    row.computedShifts[dStr].updated_at = sPivot.updated_at ? moment(sPivot.updated_at).utcOffset(-5).format("YYYY-MM-DD HH:mm") : "";
                    curDate.add(1, "days");
                  }
                }

                if (row.permissions && row.permissions.length > 0) {
                  for (let p in row.permissions) {
                    let perm = row.permissions[p];
                    let permFromMoment = moment(perm.datetime_from);
                    let permToMoment = moment(perm.datetime_to);
                    let permFromDate = permFromMoment.format("YYYY-MM-DD");
                    let permToDate = permToMoment.format("YYYY-MM-DD");
                    let tFromStr = permFromMoment.format("HH:mm");
                    let tToStr = permToMoment.format("HH:mm");
                    let isFullDay = (tFromStr === "00:00" && (tToStr === "23:59" || tToStr === "00:00"));

                    let permStart = permFromDate < week_date_from_str ? week_date_from_str : permFromDate;
                    let permEnd = permToDate > week_date_to_str ? week_date_to_str : permToDate;

                    let curDate = moment(permStart);
                    let endDate = moment(permEnd);
                    while (curDate.isSameOrBefore(endDate)) {
                      let dStr = curDate.format("YYYY-MM-DD");
                      let excDesc = perm.excuse ? perm.excuse.description : "Permiso";
                      let excColor = this.getExcuseColor(perm.excuse_id);
                      if (!row.computedShifts[dStr]) {
                        row.computedShifts[dStr] = { colspan: 1 };
                      }
                      row.computedShifts[dStr].hasExcuse = true;
                      row.computedShifts[dStr].excuse = "P: " + excDesc;
                      row.computedShifts[dStr].excuseId = perm.excuse_id;
                      row.computedShifts[dStr].excuseColor = excColor;
                      row.computedShifts[dStr].isExcuse = true;
                      row.computedShifts[dStr].observations = perm.observations;
                      row.computedShifts[dStr].timeFrom = tFromStr;
                      row.computedShifts[dStr].timeTo = tToStr;
                      row.computedShifts[dStr].isFullDay = isFullDay;
                      row.computedShifts[dStr].perm_updated_by = perm.updated_by;
                      row.computedShifts[dStr].perm_updated_at = perm.updated_at ? moment(perm.updated_at).utcOffset(-5).format("YYYY-MM-DD HH:mm") : "";
                      curDate.add(1, "days");
                    }
                  }
                }
              }

              this.assignments = response.data.data;
              this.loadingData = false;
            });
        });
    },
    // checkAssignments(row) {
    //     let hours = 0;
    //     Object.entries(row.computedShifts).forEach((entry) => {
    //         let date = moment(entry[0]);
    //         console.log(entry);
    //         for (let i = 0; i < entry[1].colspan; i++) {
    //             hours += this.shiftsHoursByDayOfWeek[entry[1].shiftId][date.format('d')];
    //             date.add(1, 'days');
    //         }
    //     })
    //     return hours;
    // },
    handleShowAssignmentNotification() {
      this.fetchExcuses();
      this.selectedOptionKey = null;
      this.shiftSelected = null;
      this.selectedShiftOption = null;
      this.showInTableShiftAssignment = true;
    },
    setDownloadUrl: function () {
      // console.log(this.$route);
      this.queryString = $.param(this.$route.query);
      if (
        this.$route.query.date_from != undefined &&
        this.$route.query.date_to != undefined &&
        this.$route.query.date_from != null &&
        this.$route.query.date_to != null
      ) {
        // this.downloadUrl = '/api' + this.baseUrl+'/download?'+this.queryString;
        this.downloadUrl = `/api/reports/shiftassignmentdatestocolumns/download?${this.queryString}`;
      } else {
        this.downloadUrl = null;
      }
    },
    downloadReport: function () {
      if (this.downloadUrl != null) {
        window.location.href = `${this.downloadUrl}&token=${localStorage.getItem("id_token")}`;
      }
    },
  },
};
</script>
